import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector, useStore } from 'react-redux';

// Slices
import mainReducer from './slices/mainSlice.js';
import seedsReducer from './slices/seedsSlice';

export const store = configureStore({
  reducer: {
    main: mainReducer,
    seeds: seedsReducer,
  },
  devTools: process.env.NODE_ENV !== 'production',
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['user/setUserData'],
        ignoredPaths: [],
      },
    }),
});

export const useAppDispatch = useDispatch.withTypes();
export const useAppSelector = useSelector.withTypes();
export const useAppStore = useStore.withTypes();
